import GLOBAL_CONFIG from '../config/config';
const static_links = {

    monthly_plans:{
        
        'WEB': GLOBAL_CONFIG.monthlyPlan.WEB,
        'ANDROID': {'OLD_APP_CONTEXT':GLOBAL_CONFIG.monthlyPlan.ANDROID,
                    'NEW_APP_CONTEXT':GLOBAL_CONFIG.monthlyPlanNewAppContext.ANDROID},
        'IOS': {'OLD_APP_CONTEXT':GLOBAL_CONFIG.monthlyPlan.IOS,
                'NEW_APP_CONTEXT':GLOBAL_CONFIG.monthlyPlanNewAppContext.IOS}
        
    },
    plan_rental: {
        'WEB': GLOBAL_CONFIG.planRental.WEB,
        'ANDROID': GLOBAL_CONFIG.planRental.ANDROID,
        'IOS': GLOBAL_CONFIG.planRental.IOS
    },
    duplicate_bills:{
        'ANDROID': GLOBAL_CONFIG.duplicateBills.ANDROID,
        'IOS': GLOBAL_CONFIG.duplicateBills.IOS
    },
    ir_pack_tnc: GLOBAL_CONFIG.irPackTnc,
    ir_pack_standard_charges: GLOBAL_CONFIG.irPackStandardCharges


};
export { static_links };


// WEBPACK FOOTER //
// ./src/constants/static_links.js